import $ from 'jquery';
import _ from 'lodash';
import React from 'react';

var Pagination = React.createClass({
    createPage: function (page, i) {
        return <Page {...page} key={i} />;
    },
    render: function() {
        var pageList = [],
            PAD = 5,
            pages = this.props.pages,
            page = this.props.page,
            first,
            second,
            secondToLast,
            last,
            urlBase,
            hashObj;
        urlBase = document.location.pathname + '#';
        hashObj = $.deparam(document.location.hash.substr(1));
        for (var i = page - PAD; i <= page + PAD; i++) {
            if (0 < i && i <= pages) {
                pageList.push({
                    activePage: page,
                    number: i,
                    active: i == page ? 'active': '',
                    url: urlBase + $.param($.extend(hashObj, {page: i}), true)
                });
            }
        }

        first = pageList[0];
        second = pageList[1];
        last = pageList[pageList.length -1];
        secondToLast = pageList[pageList.length -2];

        if (second && 3 < second.number) {
            pageList.splice(0, 0, {number: '...', disabled: true});
        }

        if (first && first.number != 1) {
            pageList.splice(0, 0, {
                activePage: page,
                number: 1,
                url: urlBase + $.param($.extend(hashObj, {page: 1}), true)
            });
        }

        if (secondToLast && secondToLast.number < pages - 2) {
            pageList.push({number: '...', disabled: true});
        }

        if (last && last.number != pages) {
            pageList.push({
                activePage: page,
                number: pages,
                url: urlBase + $.param($.extend(hashObj, {page: pages}), true)
            });
        }

        return <ul className="pagination">{_.map(pageList, this.createPage)}</ul>;
    }
});

var Page = React.createClass({
    render: function () {
        if (this.props.disabled || this.props.active) {
            var className = 'page ';
            className += this.props.disabled? 'disabled ': '';
            className += this.props.active? 'active': '';
            return (
                <li className={className}>
                    <span>{this.props.number}</span>
                </li>
            );
        }

        let rel = null;
        if (this.props.activePage + 1 === this.props.number) {
            rel = 'next';
        } else if (this.props.activePage - 1 === this.props.number) {
            rel = 'prev';
        }
        return (

            <li className="page">
                <a href={this.props.url} rel={rel}>{this.props.number}</a>
            </li>
        );
    }
});

export default Pagination;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/pagination.js
 **/